import {
  extractSalary,
  normalizeDate,
} from "../../../../../components/common/Converter";
import { parseSchedPatternFromLog } from "../utils/utils";
import { calculateTotalFromMins } from "../../helper-payroll/HelperFunction";
export const _getMinutesDeducted = (params, type) => {
  const {
    objects,
    logsByEmployee,
    dateRanges,
    isArrayDate,
    suspensions,
    holidaySet,
    suspensionSet,
    manualDtrSet,
    manualDtrSetByEmployee,
    leaveSetByEmployee,
    airportAbsentSet,
    cases,
    hasForcedOrSpecial,
    isAp,
  } = params;

  const result = [];
  const absentDateByEmployee = {};
  const halfDateByEmployee = {};
  const absentByEmployeeAirport = {};

  const toDateOnly = (d) => {
    const date = new Date(d);
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const processLog = (
    log,
    airportDutyByEmployee,
    manualDtrOfEmployee,
    employeeId,
    logsByDate,
    schedule,
    schedPattern,
    startingDate,
    optionSelected,
    twentyFourSeven,
    cases
  ) => {
    if (!log?.date)
      return {
        mins: 0,
        halfDays: 0,
        isAbsent: false,
        isHalfDay: false,
        isNextDay: false,
        isHalfDayForDay_2: false,
        logDate: null,
      };
    const logDate = normalizeDate(new Date(log.date));
    const params = {
      log,
      logsByDate,
      employeeId,
      holidaySet,
      suspensionSet,
      manualDtrSet,
      leaveSetByEmployee,
      suspensions,
      airportDutyByEmployee,
      manualDtrOfEmployee,
      schedPattern,
      twentyFourSeven,
      schedule,
      startingDate,
      cases,
      type,
      selectedOption: optionSelected,
      hasForcedOrSpecial,
      isAp,
    };
    // Deducted minutes
    const deducted = _getLogMinsDeducted(params);
    // Half day
    const halfDay = _getLogHalfday(params);

    return {
      mins: deducted?.mins ?? 0,
      isAbsent: deducted.isAbsent,
      halfDays: halfDay?.halfDays ?? 0,
      isNextDay: deducted.isNextDay,
      isHalfDayForDay_2: halfDay.isHalfDayForDay_2,
      isHalfDay: halfDay.isHalfDay,
      logDate: logDate,
    };
  };

  for (const employee of objects) {
    const employeeId = employee.id;
    const selectedOption = employee?.selectedSchedule?.selectedOption ?? "";
    const schedule = employee?.selectedSchedule?.scheduleArray ?? [];

    const isGraveyard = schedule[0]?.day?.startsWith("Graveyard");
    let logs = logsByEmployee[employeeId] || [];
    const salary = extractSalary(employee?.salaryGrade);
    const payCode = employee?.payCode;
    console.log("logs +++", logs);

    const salaryCase = cases === "isEightCase" ? payCode : salary;
    const sortedLogs = [...logs].sort(
      (a, b) => new Date(a?.date) - new Date(b?.date)
    );

    const lastDate = new Date(sortedLogs[sortedLogs.length - 1]?.date);
    const lastDateOnly = toDateOnly(lastDate);

    logs = logs.filter((log) => {
      const logDate = toDateOnly(log.date);

      // console.log("log$$", log);

      if (logDate.getTime() === lastDateOnly.getTime()) {
        //return isGraveyard || selectedOption === "Graveyard";

        // const hasGraveyardInRange = dateRanges.some(
        //   ({ startDate, endDate }) => {
        //     const start = toDateOnly(new Date(startDate));
        //     const end = toDateOnly(new Date(endDate));

        //     return logs.some((l) => {
        //       const lDate = toDateOnly(new Date(l.date));
        //       const isInRange = lDate >= start && lDate <= end;

        //       console.log("LLL", l);

        //       console.log("isInRange", isInRange);
        //       const isGraveyard =
        //         l.schedule?.scheduleArray?.[0]?.day?.startsWith("Graveyard") ??
        //         false;

        //       console.log("isGraveyard", isGraveyard);

        //       return isInRange && isGraveyard;
        //     });
        //   }
        // );
        return true;
      }

      return logDate < lastDateOnly;
    });

    // const schedPattern = schedPatternByEmployee?.[employeeId] || {};
    // const startingDate = new Date(employee?.selectedSchedule?.startingDate);
    const airportDutyByEmployee = airportAbsentSet?.[employeeId] || new Set();
    const manualDtrOfEmployee =
      manualDtrSetByEmployee?.[employeeId] || new Set();
    const twentyFourSeven = ["12", "9"].some((prefix) =>
      employee?.twentyFourSeven?.startsWith(prefix)
    );

    // Group logs by date for graveyard
    const logsByDate = {};
    // if (isGraveyard || selectedOption === "Graveyard") {
    logs.forEach((l) => {
      const key = new Date(l.date).toISOString().split("T")[0];
      if (!logsByDate[key]) logsByDate[key] = [];
      logsByDate[key].push(l);
    });
    // }
    let totalDeductedMins = isArrayDate ? Array(dateRanges.length).fill(0) : 0;
    let totalHalfDays = isArrayDate ? Array(dateRanges.length).fill(0) : 0;
    let allMinsIncurred = isArrayDate ? Array(dateRanges.length).fill(0) : 0;
    absentDateByEmployee[employeeId] = new Set();
    halfDateByEmployee[employeeId] = new Set();
    absentByEmployeeAirport[employeeId] = new Set();

    if (isArrayDate) {
      for (const log of logs) {
        const startingDate = new Date(log?.schedule?.startingDate);
        const schedPattern1 = parseSchedPatternFromLog(log);
        const newSched = log?.schedule?.scheduleArray ?? [];
        const optionSelected = log?.schedule?.selectedOption ?? "";
        const {
          mins,
          isAbsent,
          halfDays,
          isHalfDay,
          logDate,
          isNextDay,
          isHalfDayForDay_2,
        } = processLog(
          log,
          airportDutyByEmployee,
          manualDtrOfEmployee,
          employeeId,
          logsByDate,
          newSched,
          schedPattern1,
          startingDate,
          optionSelected,
          twentyFourSeven,
          cases
        );
        if (!logDate) continue;
        for (let i = 0; i < dateRanges.length; i++) {
          const range = dateRanges[i];
          const start = new Date(range.startDate);
          const end = new Date(range.endDate);
          if (logDate >= start && logDate <= end) {
            const minsIncurred = {
              mins,
              twentyFourSeven: log?.twentyFourSeven,
            };

            const minsDeductionTotal = calculateTotalFromMins(
              minsIncurred,
              salaryCase
            );

            allMinsIncurred[i] += minsDeductionTotal;

            if (isAbsent)
              absentDateByEmployee[employeeId].add(logDate.toDateString());
            if (isAbsent && type === "isForAirport")
              absentByEmployeeAirport[employeeId].add(logDate.toDateString());
            totalDeductedMins[i] += mins;
            if (isNextDay) {
              const nextDay = new Date(logDate);
              nextDay.setDate(nextDay.getDate() + 1);
              absentDateByEmployee[employeeId].add(nextDay.toDateString());

              if (type === "isForAirport") {
                absentByEmployeeAirport[employeeId].add(nextDay.toDateString());
              }
            }
            if (isHalfDay)
              halfDateByEmployee[employeeId].add(logDate.toDateString());
            if (isHalfDayForDay_2) {
              const nextDay = new Date(logDate);
              nextDay.setDate(nextDay.getDate() + 1);
              halfDateByEmployee[employeeId].add(nextDay.toDateString());
            }
            totalHalfDays[i] += halfDays;
            break;
          }
        }
      }
    } else {
      for (const log of logs) {
        const schedPattern1 = parseSchedPatternFromLog(log);
        const newSched = log?.schedule?.scheduleArray ?? [];
        const startingDate = new Date(log?.schedule?.startingDate);
        const optionSelected = log?.schedule?.selectedOption ?? "";
        const {
          mins,
          isAbsent,
          halfDays,
          isHalfDay,
          logDate,
          isNextDay,
          isHalfDayForDay_2,
        } = processLog(
          log,
          airportDutyByEmployee,
          manualDtrOfEmployee,
          employeeId,
          logsByDate,
          newSched,
          schedPattern1,
          startingDate,
          optionSelected,
          twentyFourSeven,
          cases
        );
        if (!logDate) continue;

        const minsIncurred = {
          mins,
          twentyFourSeven: log?.twentyFourSeven,
        };

        const minsDeductionTotal = calculateTotalFromMins(
          minsIncurred,
          salaryCase
        );

        allMinsIncurred += minsDeductionTotal;
        if (isAbsent)
          absentDateByEmployee[employeeId].add(logDate.toDateString());
        if (isAbsent && type === "isForAirport")
          absentByEmployeeAirport[employeeId].add(logDate.toDateString());
        if (isNextDay) {
          const nextDay = new Date(logDate);
          nextDay.setDate(nextDay.getDate() + 1);
          absentDateByEmployee[employeeId].add(nextDay.toDateString());

          if (type === "isForAirport") {
            absentByEmployeeAirport[employeeId].add(nextDay.toDateString());
          }
        }
        totalDeductedMins += mins;
        if (isHalfDay)
          halfDateByEmployee[employeeId].add(logDate.toDateString());
        if (isHalfDayForDay_2) {
          const nextDay = new Date(logDate);
          nextDay.setDate(nextDay.getDate() + 1);
          halfDateByEmployee[employeeId].add(nextDay.toDateString());
        }
        totalHalfDays += halfDays;
      }
    }

    result.push({
      employeeId,
      totalDeductedMins,
      totalHalfDays,
      allMinsIncurred,
    });
  }

  return {
    minsResult: result,
    absentDateByEmployee,
    halfDateByEmployee,
    absentByEmployeeAirport,
  };
};

const _getLogMinsDeducted = ({
  log,
  logsByDate,
  employeeId,
  holidaySet,
  suspensionSet,
  manualDtrSet,
  leaveSetByEmployee,
  suspensions,
  schedPattern,
  twentyFourSeven,
  airportDutyByEmployee,
  manualDtrOfEmployee,
  schedule,
  startingDate,
  cases,
  type,
  selectedOption,
  hasForcedOrSpecial,
  isAp,
}) => {
  console.log("cases", cases);
  // console.log("logsByDate", logsByDate);
  // console.log("LOGGG", log);
  if (Object.keys(log).length === 0) return 0;
  const logDate = new Date(log?.date);
  const logDateConverted = new Date(log.date).toDateString();
  const dayName = _getDayName(logDate);

  const isSpecialCase = [
    "isThirdCase",
    "isSecondCase",
    "isFifthCase",
    "isSixthCase",
    "isSeventhCase",
    // "isEleventhCase",
  ].includes(cases);

  if (
    (!twentyFourSeven && holidaySet.has(logDateConverted)) ||
    // (!twentyFourSeven && suspensionSet.has(logDateConverted)) ||
    // suspensionSet.has(logDateConverted) ||
    manualDtrOfEmployee.has(logDateConverted) ||
    (type !== "isForAirport" && airportDutyByEmployee.has(logDateConverted)) ||
    (isAp
      ? hasForcedOrSpecial &&
        leaveSetByEmployee[employeeId]?.has(logDateConverted)
      : leaveSetByEmployee[employeeId]?.has(logDateConverted))
  ) {
    return { mins: 0, isAbsent: false };
  }

  // Shift Cycle Schedule
  if (schedPattern.matchedSchedule && startingDate) {
    const [_, work, off] = schedPattern.matchedSchedule.map(Number);

    const cycleLength = work + off;
    const daysSinceStartIn = Math.floor(
      (logDate - startingDate) / (1000 * 60 * 60 * 24)
    );

    if (daysSinceStartIn < 0) return 0;
    const cycleDayIn =
      ((daysSinceStartIn % cycleLength) + cycleLength) % cycleLength;
    // if (cycleDay >= work) return 0;

    const isGraveyard = schedule[0]?.day?.startsWith("Graveyard");

    if (!isGraveyard && cycleDayIn >= work) {
      return 0;
    }

    // For graveyard schedules, days [0, work - 1] are working days and
    // days [work, cycleLength - 1] are off. The original condition used
    // `>` which incorrectly treated the first off-day (cycleDayIn === work)
    // as a working day, allowing logs on rest days (with only timePmIn)
    // to be processed and possibly marked as half-day.
    if (isGraveyard && cycleDayIn >= work) {
      return 0;
    }
    let rawTimeIn = "--:--";
    let rawTimeOut = "--:--";

    if (isGraveyard) {
      rawTimeIn = log?.timePmIn;

      const currentDate = new Date(log.date);
      const nextDate = new Date(currentDate);
      nextDate.setDate(currentDate.getDate() + 1);
      const nextKey = nextDate.toISOString().split("T")[0];

      const nextLog = logsByDate[nextKey];

      const timePmOut = log?.timeOut;
      const nextDayAmOut = nextLog?.[0]?.timeAmOut;
      rawTimeOut =
        timePmOut && timePmOut !== "--:--"
          ? timePmOut
          : nextDayAmOut && nextDayAmOut !== "--:--"
          ? nextDayAmOut
          : "--:--";
    } else {
      rawTimeIn = log?.timeIn !== "--:--" ? log?.timeIn : log?.timePmIn;
      rawTimeOut = log?.timeOut !== "--:--" ? log?.timeOut : log?.timeAmOut;
    }

    const actualTimeInMin = _toMinutes(rawTimeIn);
    let actualTimeOutMin = _toMinutes(rawTimeOut);

    const schedTimeInMin = _toMinutes(
      isSpecialCase
        ? schedule[0]?.lateTimeIn || schedule[0]?.timein
        : schedule[0]?.timein
    );

    let schedTimeOutMin = _toMinutes(
      isSpecialCase
        ? schedule[0]?.earliestTimeOut || schedule[0]?.timeout
        : schedule[0]?.timeout
    );

    if (schedTimeOutMin === 0) schedTimeOutMin = 1440;

    // Copy original for comparison
    let adjustedSchedOut = schedTimeOutMin;
    let adjustedActualOut = actualTimeOutMin;

    // Case 1: Employee clocked out AFTER schedule (cross-midnight)
    if (actualTimeOutMin < schedTimeOutMin) {
      // Check if it's a legit next-day out
      const diff = schedTimeOutMin - actualTimeOutMin;
      if (diff > 720) {
        // More than 12 hrs behind, probably a next-day out
        adjustedActualOut += 1440;
      }
    }

    // Case 2: Schedule is AFTER midnight, and employee out BEFORE that (e.g., out at 10 PM)
    if (actualTimeOutMin > schedTimeOutMin) {
      const diff = actualTimeOutMin - schedTimeOutMin;
      if (diff > 720) {
        // More than 12 hrs ahead, probably clocked out the previous day
        adjustedSchedOut += 1440;
      }
    }

    let rawUndertime = Math.max(adjustedSchedOut - adjustedActualOut, 0);

    // console.log("schedTimeOutMin", schedTimeOutMin);
    // console.log("actualTimeOutMinsadded", actualTimeOutMin);

    const rawLate = Math.max(actualTimeInMin - schedTimeInMin, 0);

    // console.log("rawUndertime", rawUndertime);

    const overlapIn = _getSuspensionOverlapMins(
      suspensions,
      log.date,
      schedTimeInMin,
      actualTimeInMin
    );

    const overlapOut = _getSuspensionOverlapMins(
      suspensions,
      log.date,
      actualTimeOutMin,
      schedTimeOutMin
    );

    const late = Math.max(rawLate - overlapIn, 0);
    const undertime = Math.max(rawUndertime - overlapOut, 0);
    // console.log("LATE", late);
    // console.log("undertime", undertime);
    // console.log("LOG000==", log);

    const totalMins = late + undertime;

    const hasIn = log?.timeIn !== "--:--" || log?.timePmIn !== "--:--";
    const hasOut = log?.timeOut !== "--:--" || log?.timeAmOut !== "--:--";
    const noIn = !hasIn;
    const noOut = !hasOut;

    const nextDate = new Date(logDate);
    nextDate.setDate(logDate.getDate() + 1);
    const nextKey = nextDate.toISOString().split("T")[0];
    const nextLog = logsByDate?.[nextKey]?.[0];

    const hasGraveIn = log?.timePmIn && log.timePmIn !== "--:--";
    const hasGraveOut =
      log?.timeOut && log.timeOut !== "--:--"
        ? true
        : nextLog?.timeAmOut && nextLog.timeAmOut !== "--:--";

    const noGraveIn = !hasGraveIn;
    const noGraveOut = !hasGraveOut;

    const params = {
      late,
      undertime,
      cases,
      log,
      isGraveyard,
      logsByDate,
    };

    // console.log("LOGGG", log);
    // console.log("UNDERTIME", undertime);

    if (
      ![
        "isFifthCase",
        "isSixthCase",
        "isFourthCase",
        "isTwelvethCase",
        "isEightCase",
        "isEleventhCase",
      ].includes(cases) &&
      // For normal schedule
      ((!isGraveyard &&
        ((hasIn && noOut && late <= 180) ||
          (hasOut && noIn && undertime <= 120))) ||
        // For graveyard shift
        (isGraveyard &&
          ((hasGraveIn && noGraveOut && late <= 180) ||
            (hasGraveOut && noGraveIn && undertime <= 120))))
    ) {
      return { mins: 0, isAbsent: false };
    }

    if (isGraveyard) {
      if (cycleDayIn >= work) {
        return { mins: 0, isAbsent: false };
      }
    }

    if (shouldSkipLogForCase(params, "forAbsent")) {
      return { mins: 0, isAbsent: true };
    }

    if (["isFourthCase", "isTwelvethCase", "isEightCase"].includes(cases)) {
      if (totalMins > 60) return { mins: 0, isAbsent: true };
      if (totalMins > 45) return { mins: 60, isAbsent: false };
      if (totalMins > 30) return { mins: 45, isAbsent: false };
      if (totalMins > 15) return { mins: 30, isAbsent: false };
      if (totalMins > 0) return { mins: 15, isAbsent: false };
    }

    // if (["isFourthCase", "isTwelvethCase", "isEightCase"].includes(cases)) {
    //   const convertToBracket = (mins) => {
    //     if (mins > 60) return mins; // Absence case — will be handled later
    //     if (mins > 45) return 60;
    //     if (mins > 30) return 45;
    //     if (mins > 15) return 30;
    //     if (mins > 0) return 15;
    //     return 0;
    //   };

    //   const lateBracket = convertToBracket(late);
    //   const undertimeBracket = convertToBracket(undertime);

    //   // Handle absence if either part exceeds 60 individually

    //   const totalBracket = lateBracket + undertimeBracket;
    //   if (totalBracket > 60) {
    //     return { mins: 0, isAbsent: true };
    //   }

    //   return { mins: totalBracket, isAbsent: false };
    // }

    return { mins: totalMins, isAbsent: false };
  }
  // Two Day Graveyard - 24 Hours
  if (schedPattern.twoDayGraveyardMatchList) {
    for (const {
      match,
      timein,
      timeout,
      lateTimeIn,
      earliestTimeOut,
    } of schedPattern.twoDayGraveyardMatchList) {
      const [_, day1, day2] = match;
      if (dayName === day1) {
        // Calculate late for day1
        const nextDate = new Date(logDate);
        nextDate.setDate(logDate.getDate() + 1);
        const nextKey = nextDate.toISOString().split("T")[0];
        const nextLog = logsByDate?.[nextKey]?.[0];

        const rawTimeAmIn = log?.timeIn;
        const rawTimePmIn =
          log?.timePmIn !== "--:--" ? log?.timePmIn : nextLog?.timeIn;
        const dayScheduleAm = schedule.find((s) => s?.day === dayName);
        const daySchedulePm = schedule.find(
          (s) => s?.day?.includes(dayName) && s.day.includes("-")
        );
        const rawTimePmOut = log?.timeOut;
        const rawTimeAmOut = nextLog?.timeAmOut;

        const schedTimeInAmMin = _toMinutes(
          isSpecialCase
            ? dayScheduleAm?.lateTimeIn || dayScheduleAm?.timein
            : dayScheduleAm?.timein
        );
        const schedTimeInPmMin = _toMinutes(
          isSpecialCase
            ? daySchedulePm?.lateTimeIn || daySchedulePm?.timein
            : daySchedulePm?.timein
        );
        const schedTimeOutPmMin = _toMinutes(
          isSpecialCase
            ? dayScheduleAm?.earliestTimeOut || dayScheduleAm?.timeout
            : dayScheduleAm?.timeout
        );
        const schedTimeOutAmMin = _toMinutes(
          isSpecialCase
            ? daySchedulePm?.earliestTimeOut || daySchedulePm?.timeout
            : daySchedulePm?.timeout
        );

        const timeInAmMin = _toMinutes(rawTimeAmIn);
        const timeInPmMin = _toMinutes(rawTimePmIn);
        const timeOutPmMin = _toMinutes(rawTimePmOut);
        const timeOutAmMin = _toMinutes(rawTimeAmOut);

        const late = Math.max(timeInAmMin - schedTimeInAmMin, 0);
        let undertimeForDay_1 = 0;
        let undertimeForDay_2 = 0;
        // let latePmforDay_1 = 0;
        if (timeOutPmMin > 0) {
          undertimeForDay_1 = Math.max(schedTimeOutPmMin - timeOutPmMin, 0);
        } else {
          undertimeForDay_1 = 0;
        }

        if (timeOutAmMin > 0) {
          undertimeForDay_2 = Math.max(schedTimeOutAmMin - timeOutAmMin, 0);
        } else {
          undertimeForDay_2 = 0;
        }

        const latePmforDay_1 = _calcLate(timeInPmMin, schedTimeInPmMin);

        const totalLateUTforDay_1 = late + undertimeForDay_1;
        const totalLateUTforDay_2 = latePmforDay_1 + undertimeForDay_2;

        // console.log("log", log);
        // console.log("totalLateUTforDay_1", totalLateUTforDay_1);
        // console.log("totalLateUTforDay_2", totalLateUTforDay_2);

        const totalLateUt = totalLateUTforDay_1 + totalLateUTforDay_2;

        const hasAmIn = rawTimeAmIn !== "--:--";
        const hasPmIn = rawTimePmIn !== "--:--";
        const hasPmOut = rawTimePmOut !== "--:--";
        const hasAmOut = rawTimeAmOut !== "--:--";
        const noAmIn = !hasAmIn;
        const noPmIn = !hasPmIn;
        const noPmOut = !hasPmOut;
        const noAmOut = !hasAmOut;

        const logCheck = {
          hasAmIn,
          hasPmIn,
          hasPmOut,
          hasAmOut,
          noAmIn,
          noPmIn,
          noPmOut,
          noAmOut,
        };

        const params = {
          late,
          latePmforDay_1,
          undertimeForDay_1,
          undertimeForDay_2,
          totalLateUTforDay_1,
          totalLateUTforDay_2,
          cases,
          log,
          logsByDate,
          selectedOption,
          logCheck,
        };

        const skipResult = shouldSkipLogForCase(params, "forAbsent");
        const isAbsent = skipResult?.includes?.("isAbsent") ?? false;
        const isNextDay = skipResult?.includes?.("isNextDay") ?? false;

        // console.log("isNextDay", isNextDay);
        // console.log("LOG", log);

        // console.log("skipResult", skipResult);
        const day1Result = (() => {
          if (isAbsent || isNextDay) {
            return {
              mins: 0,
              isAbsent: isAbsent,
              isNextDay: isNextDay,
            };
          }

          // console.log("totalLateUTforDay_1", totalLateUTforDay_1);

          if (
            ["isFourthCase", "isTwelvethCase", "isEightCase"].includes(cases)
          ) {
            if (totalLateUTforDay_1 > 60)
              return { mins: 0, isAbsent: true, isNextDay: false };
            // if (totalLateUTforDay_2 > 60)
            //   return { mins: 0, isAbsent: false, isNextDay: true };
            if (totalLateUTforDay_1 > 45)
              return { mins: 60, isAbsent: false, isNextDay: false };
            if (totalLateUTforDay_1 > 30)
              return { mins: 45, isAbsent: false, isNextDay: false };
            if (totalLateUTforDay_1 > 15)
              return { mins: 30, isAbsent: false, isNextDay: false };
            if (totalLateUTforDay_1 > 0)
              return { mins: 15, isAbsent: false, isNextDay: false };
            return { mins: 0, isAbsent: false, isNextDay: false };
          }

          return {
            mins: totalLateUTforDay_1,
            isAbsent: false,
            isNextDay: false,
          };
        })();

        const totalMins =
          day1Result.mins + (day1Result.isNextDay ? 0 : totalLateUTforDay_2);

        return {
          mins: totalMins,
          isAbsent: day1Result.isAbsent,
          isNextDay: day1Result.isNextDay,
        };
      }
    }
  }
  // Alternate Schedule
  if (schedPattern.workingDaysAlt) {
    if (!schedPattern.workingDaysAlt.includes(dayName)) return 0;
    const actualTimeInMin = _toMinutes(log?.timeIn);
    const actualTimeOutMin = _toMinutes(log?.timeOut);
    const schedTimeInMin = _toMinutes(schedule[0]?.timein);
    const schedTimeOutMin = _toMinutes(schedule[0]?.timeout);
    const late = Math.max(actualTimeInMin - schedTimeInMin, 0);
    const undertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);
    return late + undertime;
  }
  // Default: Regular Schedule
  const daySchedule = schedule.find((s) => s?.day === dayName);
  if (!daySchedule) return { mins: 0, isAbsent: false };

  const rawTimeIn = log?.timeIn !== "--:--" ? log?.timeIn : log?.timePmIn;
  const rawTimeOut = log?.timeOut !== "--:--" ? log?.timeOut : log?.timeAmOut;


  const isnotJOCase = [
    "isThirdCase",
    "isSecondCase",
    "isSeventhCase",
    // "isEleventhCase",
  ].includes(cases);
  const rawlateTimeIn = isnotJOCase
    ? daySchedule?.lateTimeIn || daySchedule?.timein
    : daySchedule?.timein;


  const rawLateTimeOut = isnotJOCase
    ? daySchedule?.earliestTimeOut || daySchedule?.timeout
    : daySchedule?.timeout;

  const actualTimeInMin = _toMinutes(rawTimeIn);
  const actualTimeOutMin = _toMinutes(rawTimeOut);
  const schedTimeInMin = _toMinutes(rawlateTimeIn);
  const schedTimeOutMin = _toMinutes(rawLateTimeOut);
  const rawLate = Math.max(actualTimeInMin - schedTimeInMin, 0);
  const rawUndertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);

  const overlapIn = _getSuspensionOverlapMins(
    suspensions,
    log.date,
    schedTimeInMin,
    actualTimeInMin
  );

  const overlapOut = _getSuspensionOverlapMins(
    suspensions,
    log.date,
    actualTimeOutMin,
    schedTimeOutMin
  );

  const late = Math.max(rawLate - overlapIn, 0);
  const undertime = Math.max(rawUndertime - overlapOut, 0);
  const totalMins = late + undertime;

  const hasIn = log?.timeIn !== "--:--" || log?.timePmIn !== "--:--";
  const hasOut = log?.timeOut !== "--:--" || log?.timeAmOut !== "--:--";
  const noIn = !hasIn;
  const noOut = !hasOut;

  const params = {
    late,
    undertime,
    cases,
    log,
  };

  if (
    ![
      "isFifthCase",
      "isSixthCase",
      "isFourthCase",
      "isTwelvethCase",
      "isEightCase",
      "isEleventhCase",
    ].includes(cases) &&
    ((hasIn && noOut && late <= 180) || (hasOut && noIn && undertime <= 120))
  ) {
    return { mins: 0, isAbsent: false };
  }

  if (shouldSkipLogForCase(params, "forAbsent")) {
    return { mins: 0, isAbsent: true };
  }

  if (["isFourthCase", "isTwelvethCase", "isEightCase"].includes(cases)) {
    if (totalMins > 60) return { mins: 0, isAbsent: true };
    if (totalMins > 45) return { mins: 60, isAbsent: false };
    if (totalMins > 30) return { mins: 45, isAbsent: false };
    if (totalMins > 15) return { mins: 30, isAbsent: false };
    if (totalMins > 0) return { mins: 15, isAbsent: false };
    return { mins: 0, isAbsent: false };
  }

  return { mins: totalMins, isAbsent: false };
};
const _getLogHalfday = ({
  log,
  logsByDate,
  employeeId,
  holidaySet,
  suspensionSet,
  manualDtrSet,
  leaveSetByEmployee,
  manualDtrOfEmployee,
  schedPattern,
  twentyFourSeven,
  schedule,
  startingDate,
  suspensions,
  cases,
  selectedOption,
  hasForcedOrSpecial,
  isAP,
}) => {
  if (Object.keys(log).length === 0) return 0;
  const logDate = new Date(log?.date);
  const logDateConverted = new Date(log.date).toDateString();
  const dayName = _getDayName(logDate);

  const isSpecialCase = [
    "isThirdCase",
    "isSecondCase",
    "isFifthCase",
    "isSixthCase",
    "isSeventhCase",
  ].includes(cases);

  const _getDateOnly = (dateTimeStr) => {
    if (!dateTimeStr) return null;
    const [datePart] = dateTimeStr.split(" at ");
    return new Date(datePart);
  };

  const suspension = (suspensions || []).find((sus) => {
    if (!sus.dateFrom || !sus.dateTo) return false;
    const susFromDate = _getDateOnly(sus.dateFrom);
    const susToDate = _getDateOnly(sus.dateTo);
    const logDay = new Date(logDate.toDateString());
    return (
      susFromDate && susToDate && logDay >= susFromDate && logDay <= susToDate
    );
  });

  const _isOutBeforeSuspension = (outTime, susStart) => {
    if (!outTime || outTime === "--:--" || !susStart) return true;
    const [h, m] = outTime.split(":").map(Number);
    const outDate = new Date(susStart);
    outDate.setHours(h, m, 0, 0);
    return outDate < susStart;
  };

  const _getSuspensionStart = (suspension) => {
    if (!suspension || !suspension.dateFrom) return null;
    return _parseSuspensionDate(suspension.dateFrom);
  };

  // Shift Cycle Schedule
  if (schedPattern.matchedSchedule && startingDate) {
    const [_, work, off] = schedPattern.matchedSchedule.map(Number);
    const cycleLength = work + off;
    const daysSinceStartIn = Math.floor(
      (logDate - startingDate) / (1000 * 60 * 60 * 24)
    );
    if (daysSinceStartIn < 0) return 0;
    const cycleDayIn =
      ((daysSinceStartIn % cycleLength) + cycleLength) % cycleLength;
    // if (cycleDay >= work) return 0;

    const isGraveyard = schedule[0]?.day?.startsWith("Graveyard");

    if (!isGraveyard && cycleDayIn >= work) {
      return 0;
    }

    if (isGraveyard && cycleDayIn > work) {
      return 0;
    }

    let rawTimeIn = "--:--";
    let rawTimeOut = "--:--";

    if (isGraveyard) {
      rawTimeIn = log?.timePmIn;

      const currentDate = new Date(log.date);
      const nextDate = new Date(currentDate);
      nextDate.setDate(currentDate.getDate() + 1);
      const nextKey = nextDate.toISOString().split("T")[0];

      const nextLog = logsByDate[nextKey];
      const timePmOut = log?.timeOut;
      const nextDayAmOut = nextLog?.[0]?.timeAmOut;
      rawTimeOut =
        timePmOut && timePmOut !== "--:--"
          ? timePmOut
          : nextDayAmOut && nextDayAmOut !== "--:--"
          ? nextDayAmOut
          : "--:--";
    } else {
      rawTimeIn = log?.timeIn !== "--:--" ? log?.timeIn : log?.timePmIn;
      rawTimeOut = log?.timeOut !== "--:--" ? log?.timeOut : log?.timeAmOut;
    }

    const actualTimeInMin = _toMinutes(rawTimeIn);
    let actualTimeOutMin = _toMinutes(rawTimeOut);

    const schedTimeInMin = _toMinutes(
      isSpecialCase
        ? schedule[0]?.lateTimeIn || schedule[0]?.timein
        : schedule[0]?.timein
    );

    let schedTimeOutMin = _toMinutes(
      isSpecialCase
        ? schedule[0]?.earliestTimeOut || schedule[0]?.timeout
        : schedule[0]?.timeout
    );

    const rawLate = Math.max(actualTimeInMin - schedTimeInMin, 0);

    // if (schedTimeOutMin < actualTimeOutMin) {
    //   schedTimeOutMin += 1440;
    // }
    if (schedTimeOutMin === 0) schedTimeOutMin = 1440;

    // Copy original for comparison
    let adjustedSchedOut = schedTimeOutMin;
    let adjustedActualOut = actualTimeOutMin;

    // Case 1: Employee clocked out AFTER schedule (cross-midnight)
    if (actualTimeOutMin < schedTimeOutMin) {
      // Check if it's a legit next-day out
      const diff = schedTimeOutMin - actualTimeOutMin;
      if (diff > 720) {
        // More than 12 hrs behind, probably a next-day out
        adjustedActualOut += 1440;
      }
    }

    // Case 2: Schedule is AFTER midnight, and employee out BEFORE that (e.g., out at 10 PM)
    if (actualTimeOutMin > schedTimeOutMin) {
      const diff = actualTimeOutMin - schedTimeOutMin;
      if (diff > 720) {
        // More than 12 hrs ahead, probably clocked out the previous day
        adjustedSchedOut += 1440;
      }
    }

    let rawUndertime = Math.max(adjustedSchedOut - adjustedActualOut, 0);

    const overlapIn = _getSuspensionOverlapMins(
      suspensions,
      log.date,
      schedTimeInMin,
      actualTimeInMin
    );

    const overlapOut = _getSuspensionOverlapMins(
      suspensions,
      log.date,
      actualTimeOutMin,
      schedTimeOutMin
    );

    const late = Math.max(rawLate - overlapIn, 0);
    const undertime = Math.max(rawUndertime - overlapOut, 0);

    const params = {
      cases,
      log,
      late,
      undertime,
      schedPattern,
      logsByDate,
      isGraveyard,
    };

    if (
      (!twentyFourSeven && holidaySet.has(logDateConverted)) ||
      (!twentyFourSeven && suspensionSet.has(logDateConverted)) ||
      manualDtrOfEmployee.has(logDateConverted) ||
      isAP
        ? hasForcedOrSpecial &&
          leaveSetByEmployee[employeeId]?.has(logDateConverted)
        : leaveSetByEmployee[employeeId]?.has(logDateConverted)
    ) {
      return { halfDays: 0, isHalfDay: false };
    }

    if (shouldSkipLogForCase(params, "forHalfDay")) {
      return { halfDays: 1, isHalfDay: true };
    }

    return { halfDays: 0, isHalfDay: false };
  }
  // Two Day Graveyard
  if (schedPattern.twoDayGraveyardMatchList) {
    for (const {
      match,
      timein,
      timeout,
      lateTimeIn,
      earliestTimeOut,
    } of schedPattern.twoDayGraveyardMatchList) {
      const [_, day1, day2] = match;
      if (dayName === day1) {
        // Calculate late for day1
        const nextDate = new Date(logDate);
        nextDate.setDate(logDate.getDate() + 1);
        const nextKey = nextDate.toISOString().split("T")[0];
        const nextLog = logsByDate?.[nextKey]?.[0];

        const rawTimeAmIn = log?.timeIn;
        const rawTimePmIn =
          log?.timePmIn !== "--:--" ? log?.timePmIn : nextLog?.timeIn;
        const dayScheduleAm = schedule.find((s) => s?.day === dayName);
        const daySchedulePm = schedule.find(
          (s) => s?.day?.includes(dayName) && s.day.includes("-")
        );
        const rawTimePmOut = log?.timeOut;
        const rawTimeAmOut = nextLog?.timeAmOut;

        const schedTimeInAmMin = _toMinutes(
          isSpecialCase
            ? dayScheduleAm?.lateTimeIn || dayScheduleAm?.timein
            : dayScheduleAm?.timein
        );
        const schedTimeInPmMin = _toMinutes(
          isSpecialCase
            ? daySchedulePm?.lateTimeIn || daySchedulePm?.timein
            : daySchedulePm?.timein
        );
        const schedTimeOutPmMin = _toMinutes(
          isSpecialCase
            ? dayScheduleAm?.earliestTimeOut || dayScheduleAm?.timeout
            : dayScheduleAm?.timeout
        );
        const schedTimeOutAmMin = _toMinutes(
          isSpecialCase
            ? daySchedulePm?.earliestTimeOut || daySchedulePm?.timeout
            : daySchedulePm?.timeout
        );

        const timeInAmMin = _toMinutes(rawTimeAmIn);
        const timeInPmMin = _toMinutes(rawTimePmIn);
        const timeOutPmMin = _toMinutes(rawTimePmOut);
        const timeOutAmMin = _toMinutes(rawTimeAmOut);

        const late = Math.max(timeInAmMin - schedTimeInAmMin, 0);
        let undertimeForDay_1 = 0;
        let undertimeForDay_2 = 0;

        if (timeOutPmMin > 0) {
          undertimeForDay_1 = Math.max(schedTimeOutPmMin - timeOutPmMin, 0);
        } else {
          undertimeForDay_1 = 0;
        }

        if (timeOutAmMin > 0) {
          undertimeForDay_2 = Math.max(schedTimeOutAmMin - timeOutAmMin, 0);
        } else {
          undertimeForDay_2 = 0;
        }

        const latePmforDay_1 = _calcLate(timeInPmMin, schedTimeInPmMin);

        const totalLateUTforDay_1 = late + undertimeForDay_1;
        const totalLateUTforDay_2 = latePmforDay_1 + undertimeForDay_2;

        // console.log("log", log);

        let undertime = 0;

        const totalLateUt = late + undertime;

        const hasAmIn = rawTimeAmIn !== "--:--";
        const hasPmIn = rawTimePmIn !== "--:--";
        const hasPmOut = rawTimePmOut !== "--:--";
        const hasAmOut = rawTimeAmOut !== "--:--";
        const noAmIn = !hasAmIn;
        const noPmIn = !hasPmIn;
        const noPmOut = !hasPmOut;
        const noAmOut = !hasAmOut;

        const logCheck = {
          hasAmIn,
          hasPmIn,
          hasPmOut,
          hasAmOut,
          noAmIn,
          noPmIn,
          noPmOut,
          noAmOut,
        };

        const params = {
          late,
          latePmforDay_1,
          undertimeForDay_1,
          undertimeForDay_2,
          totalLateUTforDay_1,
          totalLateUTforDay_2,
          cases,
          log,
          logsByDate,
          selectedOption,
          logCheck,
        };

        if (
          (!twentyFourSeven && holidaySet.has(logDateConverted)) ||
          (!twentyFourSeven && suspensionSet.has(logDateConverted)) ||
          manualDtrSet.has(logDateConverted) ||
          isAP
            ? hasForcedOrSpecial &&
              leaveSetByEmployee[employeeId]?.has(logDateConverted)
            : leaveSetByEmployee[employeeId]?.has(logDateConverted)
        ) {
          return { halfDays: 0, isHalfDay: false, isHalfDayForDay_2: false };
        }

        // if (this.shouldSkipLogForCase(params, "forHalfDay")) {
        //   return { halfDays: 1, isHalfDay: true };
        // }

        const skipResult = shouldSkipLogForCase(params, "forHalfDay");

        if (skipResult === "isHalfDayforDay_1") {
          return { halfDays: 1, isHalfDay: true, isHalfDayForDay_2: false };
        }

        if (skipResult === "isHalfDayforDay_2") {
          return { halfDays: 1, isHalfDayForDay_2: true, isHalfDay: false };
        }

        return { halfDays: 0, isHalfDay: false, isHalfDayForDay_2: false };
      }
    }
  }
  // Alternate Schedule
  if (schedPattern.workingDaysAlt) {
    if (!schedPattern.workingDaysAlt.includes(dayName)) return 0;
    const hasIn = log?.timeIn && log.timeIn !== "--:--";
    const noOut = !log?.timeOut || log.timeOut === "--:--";
    if (suspension && hasIn) {
      const susStart = _getSuspensionStart(suspension);
      if (noOut) return 1;
      if (_isOutBeforeSuspension(log.timeOut, susStart)) return 1;
      return 0;
    }
    return hasIn && noOut ? 1 : 0;
  }
  // Default: Regular Schedule
  const daySchedule = schedule.find((s) => s?.day === dayName);
  if (!daySchedule) return 0;
  const rawTimeIn = log?.timeIn !== "--:--" ? log?.timeIn : log?.timePmIn;
  const rawTimeOut = log?.timeOut !== "--:--" ? log?.timeOut : log?.timeAmOut;

  const isnotJOCase = [
    "isThirdCase",
    "isSecondCase",
    "isSeventhCase",
    // "isEleventhCase",
  ].includes(cases);

  const rawlateTimeIn = isnotJOCase
    ? daySchedule?.lateTimeIn || daySchedule?.timein
    : daySchedule?.timein;

  const rawLateTimeOut = isnotJOCase
    ? daySchedule?.earliestTimeOut || daySchedule?.timeout
    : daySchedule?.timeout;

  const actualTimeInMin = _toMinutes(rawTimeIn);
  const actualTimeOutMin = _toMinutes(rawTimeOut);
  const schedTimeInMin = _toMinutes(rawlateTimeIn);
  const schedTimeOutMin = _toMinutes(rawLateTimeOut);

  const late = Math.max(actualTimeInMin - schedTimeInMin, 0);
  const undertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);

  const params = {
    cases,
    log,
    late,
    undertime,
    schedPattern,
  };

  if (
    (!twentyFourSeven && holidaySet.has(logDateConverted)) ||
    (!twentyFourSeven && suspensionSet.has(logDateConverted)) ||
    manualDtrSet.has(logDateConverted) ||
    isAP
      ? hasForcedOrSpecial &&
        leaveSetByEmployee[employeeId]?.has(logDateConverted)
      : leaveSetByEmployee[employeeId]?.has(logDateConverted)
  ) {
    return { halfDays: 0, isHalfDay: false };
  }

  if (shouldSkipLogForCase(params, "forHalfDay")) {
    return { halfDays: 1, isHalfDay: true };
  }

  return { halfDays: 0, isHalfDay: false };
};

const _parseSuspensionDate = (dateStr) => {
  if (!dateStr) return null;
  const [datePart, timePart] = dateStr.split(" at ");
  if (!datePart || !timePart) return null;
  const combined = `${datePart} ${timePart}`;
  return new Date(combined);
};

const _getDayName = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", { weekday: "long" });
};
const _toMinutes = (timeStr, isTimeOut = false) => {
  if (!timeStr || typeof timeStr !== "string" || !timeStr.includes(":") || timeStr === "--:--") {
    return 0;
  }

  const [hour, minute] = timeStr.split(":").map(Number);
  let total = hour * 60 + minute;

  // if (!isTimeOut && total < 300) {
  //   return total + 1440;
  // }

  // if (!isTimeOut && hour === 0 && minute === 0) {
  //   return 720;
  // }

  if (!isTimeOut && total < 60) {
    return total + 1440;
  }

  return total;
};

const shouldSkipLogForCase = (
  {
    late,
    undertime,
    latePmforDay_1,
    undertimeForDay_1,
    undertimeForDay_2,
    totalLateUTforDay_1,
    totalLateUTforDay_2,
    cases,
    log,
    schedPattern,
    isGraveyard,
    logsByDate,
    selectedOption,
    logCheck,
  },
  type
) => {
  const hasIn = log?.timeIn !== "--:--" || log?.timePmIn !== "--:--";
  const hasOut = log?.timeOut !== "--:--" || log?.timeAmOut !== "--:--";
  const noIn = !hasIn;
  const noOut = !hasOut;
  const totalLateUT = late + undertime;

  const _graveyardLogStatus = () => {
    const logDate = new Date(log.date);
    const nextDate = new Date(logDate);
    nextDate.setDate(logDate.getDate() + 1);
    const nextKey = nextDate.toISOString().split("T")[0];
    const nextLog = logsByDate?.[nextKey]?.[0];

    const hasGraveIn = log?.timePmIn && log.timePmIn !== "--:--";
    const hasGraveOut =
      log?.timeOut && log.timeOut !== "--:--"
        ? true
        : nextLog?.timeAmOut && nextLog.timeAmOut !== "--:--";

    return {
      hasGraveIn,
      hasGraveOut,
      noGraveIn: !hasGraveIn,
      noGraveOut: !hasGraveOut,
    };
  };

  // Case rules configuration
  const absentRules = {
    isBasic:
      type === "forAbsent" &&
      ["isThirdCase", "isSecondCase", "isSeventhCase"].includes(cases),
    isAP:
      type === "forAbsent" &&
      ["isFourthCase", "isTwelvethCase", "isEightCase"].includes(cases),
    isJO: ["isFifthCase", "isSixthCase", "isEleventhCase"].includes(cases),
  };

  // Absent: Basic
  if (absentRules.isBasic) {
    if (!isGraveyard && selectedOption !== "Graveyard") {
      if (
        (noIn && noOut) ||
        totalLateUT > 240 ||
        (hasIn && noOut && late > 180) ||
        (noIn && hasOut && undertime > 120)
      )
        return true;
    } else if (selectedOption === "Graveyard") {
      const {
        hasAmIn,
        hasPmIn,
        hasPmOut,
        hasAmOut,
        noAmIn,
        noPmIn,
        noPmOut,
        noAmOut,
      } = logCheck;

      if (
        (hasAmIn && noPmOut && late > 180) ||
        (noAmIn && hasPmOut && undertimeForDay_1 > 120) ||
        totalLateUTforDay_1 > 240 ||
        (noAmIn && noPmOut)
      ) {
        return "isAbsent";
      } else if (
        (hasPmIn && noAmOut && latePmforDay_1 > 180) ||
        (noPmIn && hasAmOut && undertimeForDay_2 > 120) ||
        totalLateUTforDay_2 > 240 ||
        (noPmIn && noAmOut)
      ) {
        return "isNextDay";
      }
      return false;
    } else {
      const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } =
        _graveyardLogStatus();

      if (
        (hasGraveIn && noGraveOut && late > 180) ||
        (hasGraveOut && noGraveIn && undertime > 120) ||
        totalLateUT > 240 ||
        (noGraveIn && noGraveOut)
      )
        return true;
      return false;
    }
  }

  // Absent: AP
  if (absentRules.isAP) {
    if (!isGraveyard && selectedOption !== "Graveyard") {
      if (
        late > 61 ||
        undertime > 61 ||
        (hasIn && noOut) ||
        (noIn && hasOut) ||
        (noIn && noOut)
      )
        return true;
    } else if (selectedOption === "Graveyard") {
      const {
        hasAmIn,
        hasPmIn,
        hasPmOut,
        hasAmOut,
        noAmIn,
        noPmIn,
        noPmOut,
        noAmOut,
      } = logCheck;
      const result = [];

      if (
        late > 61 ||
        undertimeForDay_1 > 61 ||
        (hasAmIn && noPmOut) ||
        (noAmIn && hasPmOut) ||
        (noAmIn && noPmOut)
      ) {
        result.push("isAbsent");
      }
      if (
        latePmforDay_1 > 61 ||
        undertimeForDay_2 > 61 ||
        (hasPmIn && noAmOut) ||
        (noPmIn && hasAmOut) ||
        (noPmIn && noAmOut)
      ) {
        result.push("isNextDay");
      }

      return result.length > 0 ? result : false;
    } else {
      const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } =
        _graveyardLogStatus();
      if (
        late > 61 ||
        undertime > 61 ||
        (hasGraveIn && noGraveOut) ||
        (noGraveIn && hasGraveOut) ||
        (noGraveIn && noGraveOut)
      )
        return true;
      return false;
    }
  }

  // Absent: JO
  if (absentRules.isJO) {
    if (!isGraveyard && selectedOption !== "Graveyard") {
      if (
        (noIn && hasOut) ||
        (hasIn && noOut) ||
        (noIn && noOut)
        // totalLateUT > 240
      )
        return true;
    } else if (selectedOption === "Graveyard") {
      const {
        hasAmIn,
        hasPmIn,
        hasPmOut,
        hasAmOut,
        noAmIn,
        noPmIn,
        noPmOut,
        noAmOut,
      } = logCheck;

      const result = [];

      if ((hasAmIn && noPmOut) || (noAmIn && hasPmOut) || (noAmIn && noPmOut)) {
        result.push("isAbsent");
      }
      if ((hasPmIn && noAmOut) || (noPmIn && hasAmOut) || (noPmIn && noAmOut)) {
        result.push("isNextDay");
      }

      return result.length > 0 ? result : false;
    } else {
      const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } =
        _graveyardLogStatus();
      if (
        (hasGraveIn && noGraveOut) ||
        (noGraveIn && hasGraveOut) ||
        (noGraveIn && noGraveOut)
      )
        return true;
      return false;
    }
  }

  // Half-day: Basic
  if (
    ["isThirdCase", "isSecondCase", "isSeventhCase"].includes(cases) &&
    type === "forHalfDay"
  ) {
    const isMatchSchedule =
      Array.isArray(schedPattern?.matchedSchedule) &&
      schedPattern.matchedSchedule.length > 0;

    //half-day non-graveyard
    if (isMatchSchedule && !isGraveyard && selectedOption !== "Graveyard") {
      return (
        (noIn && hasOut && undertime <= 120) || (hasIn && noOut && late <= 180)
      );
    }
    //half-day graveyard
    if (isGraveyard) {
      const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } =
        _graveyardLogStatus();
      if (
        (hasGraveIn && noGraveOut && late <= 180) ||
        (hasGraveOut && noGraveIn && undertime <= 120)
      )
        return true;
      return false;
    }
    if (selectedOption === "Graveyard") {
      const {
        hasAmIn,
        hasPmIn,
        hasPmOut,
        hasAmOut,
        noAmIn,
        noPmIn,
        noPmOut,
        noAmOut,
      } = logCheck;

      if (
        (hasAmIn && noPmOut && late <= 180) ||
        (hasPmOut && noAmIn && undertimeForDay_1 <= 120)
      ) {
        return "isHalfDayforDay_1";
      } else if (
        (hasPmIn && noAmOut && latePmforDay_1 <= 180) ||
        (noPmIn && hasAmOut && undertimeForDay_2 <= 120)
      ) {
        return "isHalfDayforDay_2";
      }
      return false;
    }

    // For regular schedules like 4,2-3,2, etc.
    return (
      (noIn && hasOut && undertime <= 120) || (hasIn && noOut && late <= 180)
    );
  }

  return false;
};

const _getSuspensionOverlapMins = (
  suspensions,
  logDate,
  rangeStartMin,
  rangeEndMin
) => {
  const dayStart = new Date(logDate);
  let totalOverlap = 0;

  for (const suspension of suspensions) {
    const from = new Date(suspension.dateFrom);
    const to = new Date(suspension.dateTo);

    if (from.toDateString() !== dayStart.toDateString()) continue;

    const suspensionStartMin = from.getHours() * 60 + from.getMinutes();
    const suspensionEndMin = to.getHours() * 60 + to.getMinutes();

    const overlapStart = Math.max(rangeStartMin, suspensionStartMin);
    const overlapEnd = Math.min(rangeEndMin, suspensionEndMin);

    if (overlapStart < overlapEnd) {
      totalOverlap += overlapEnd - overlapStart;
    }
  }

  return totalOverlap;
};

const _calcLate = (timeInPmMin, schedTimeInPmMin) => {
  const MINUTES_IN_DAY = 1440;
  const HALF_DAY = MINUTES_IN_DAY / 2;
  if (timeInPmMin === 0) return 0;
  let diff = timeInPmMin - schedTimeInPmMin;

  if (diff < -HALF_DAY) diff += MINUTES_IN_DAY;

  return Math.max(diff, 0);
};

// const parseSchedPatternFromLog = (log) => {
//   const schedule = log?.schedule?.scheduleArray ?? [];
//   const scheduleName = schedule[0]?.day || "";
//   const selectedOption = log?.schedule?.selectedOption || "";

//   const graveyardMatch = scheduleName.match(
//     /^Graveyard (\d+)days Working, (\d+)days off$/
//   );
//   const regularMatch = scheduleName.match(
//     /^Regular (\d+)days Working, (\d+)days off$/
//   );
//   const plainCycleMatch = scheduleName.match(
//     /^(\d+)days Working, (\d+)days off$/
//   );

//   const alternateMWFMatch = selectedOption === "Alternate (MWF)";
//   const alternateTTHSMatch = selectedOption === "Alternate (TTHS)";
//   const isAlternateSchedule = alternateMWFMatch || alternateTTHSMatch;

//   const workingDaysAlt = alternateMWFMatch
//     ? ["Monday", "Wednesday", "Friday"]
//     : alternateTTHSMatch
//     ? ["Tuesday", "Thursday", "Saturday"]
//     : [];

//   const matchedSchedule = graveyardMatch || regularMatch || plainCycleMatch;

//   const twoDayGraveyardMatchList = [];
//   if (selectedOption === "Graveyard") {
//     for (const sched of schedule) {
//       const name = sched?.day || "";
//       const match = name.match(/^(\w+) - (\w+)$/);
//       if (match) {
//         twoDayGraveyardMatchList.push({
//           match,
//           timein: sched.timein,
//           timeout: sched.timeout,
//           earliestTimeOut: sched.earliestTimeOut,
//           lateTimeIn: sched.lateTimeIn,
//         });
//       }
//     }
//   }

//   if (matchedSchedule) return { matchedSchedule };
//   if (twoDayGraveyardMatchList.length > 0) return { twoDayGraveyardMatchList };
//   if (isAlternateSchedule) return { workingDaysAlt };
//   return { selectedOption };
// };
